import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15.5 9h-10c-.275 0-.5.225-.5.5v6c0 .275.225.5.5.5h10c.275 0 .5-.225.5-.5v-6c0-.275-.225-.5-.5-.5zM11 12h4v1h-4v-1zm-1 1H6v-1h4v1zm1-2v-1h4v1h-4zm-1 0H6v-1h4v1zm-4 3h4v1H6v-1zm5 0h4v1h-4v-1z',
    'M16 2H5c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 3h11c.551 0 1 .449 1 1v1H4V4c0-.551.449-1 1-1zm11 15H5c-.551 0-1-.449-1-1V6h13v11c0 .551-.449 1-1 1z',
  ],
  height: 20,
  width: 22,
});
